// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__1kTci","page-content":"styles_page-content__3HNHj","page-footer":"styles_page-footer__3Tw1v"};